/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { useEffect } from 'react';

export function useTitle(title: string) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}
